const getPlatform = () => ({
  isMac: navigator.platform.includes("Mac"),
  isWin: navigator.platform.includes("Win"),
  isSafari: /^((?!chrome|android).)*safari/i.test(navigator.userAgent),
  isFirefox: "netscape" in window && / rv:/.test(navigator.userAgent)
});

export { getPlatform };
//# sourceMappingURL=platform.js.map
